import React from "react";
import {Bar} from "react-chartjs-2";

import {
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend
} from "chart.js";
import NoDataMessage from "../../../../../components/noDataMessage";
import LoadingBarChart from "../components/loadingBarChart";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MilestoneChart = ({
                            data,
                            loading = true,
                            title = '',
                            mainBackground = 'rgb(58, 70, 169)',
                            secondaryBackground = '#ECEDF7',
                            label = 'FP',
                            barThickness = 30,
                            labelsTableRowThickness = "39px",
                            barHeight = 64.4,
                        }) => {
    const summeValues = data.map((item) => parseFloat(item.FP).toFixed(1));

    const chartData = {
        labels: data.map(() => ""), // No labels in the chart itself
        datasets: [{
            label: label,
            data: summeValues,
            backgroundColor: mainBackground,
            borderColor: mainBackground,
            borderWidth: 1,
        },],
    };

    const options = {
        indexAxis: "y", // Horizontal bar chart
        responsive: true, maintainAspectRatio: false, plugins: {
            legend: {
                display: false,
            }, title: {
                display: title.length > 0, text: title,
            },tooltip: {
                callbacks: {
                    label: function (context) {
                        const value = parseFloat(context.raw);
                        return `${context.dataset.label}: ${value.toLocaleString("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 })}`;
                    }
                }
            }
        }, scales: {
            x: {
                beginAtZero: true,
            }, y: {
                display: true,
            },
        },
        barThickness: barThickness,
        onHover: (event, elements) => {
            if (elements.length > 0) {
                event.native.target.style.cursor = 'pointer';
            } else {
                event.native.target.style.cursor = 'default';
            }
        },
        onClick: (event, elements) => {
            if (elements.length > 0) {
                const chartElement = elements[0];
                const index = chartElement.index;
                const clickedItem = data[index];

                if (clickedItem?.No) {
                    const url = `${window.location.origin}/firmenprojekte-liste/${clickedItem.No}`;
                    window.open(url, "_blank");
                }
            }
        },
    };

    return (loading ? (<LoadingBarChart/>) : (<div style={{display: "flex", alignItems: "stretch", width: "100%"}}>
        {data.length === 0 ? (<NoDataMessage message="No data to display"/>) : (<>
            {/* Table for labels */}
            <div style={{width: "45%", zIndex: "1"}}>
                <table style={{
                    width: "100%", borderCollapse: "collapse", fontSize: "15px", tableLayout: "fixed"
                }}>
                    <thead>
                    <tr style={{borderBottom: "2px solid #ddd"}}>
                        <th style={{
                            textAlign: "left", fontWeight: "bold", padding: "6px", width: "2vw"
                        }}>#
                        </th>
                        <th style={{textAlign: "left", fontWeight: "bold", padding: "0"}}>Projekt-Fortschritt (Meilenstein)</th>
                        <th style={{
                            textAlign: "right", fontWeight: "bold", padding: "6px", width: "5vw"
                        }}>MA
                        </th>
                        <th style={{
                            textAlign: "right", fontWeight: "bold", padding: "6px", width: "13%"
                        }}>{label}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((item, index) => (<tr key={index} style={{borderBottom: "1px solid #ddd"}}>
                        <td style={{
                            textAlign: "left", padding: "6px", fontWeight: "bold"
                        }}>{index + 1}</td>
                        <td style={{
                            padding: "6px",
                            textAlign: "left",
                            height: labelsTableRowThickness,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{item.Fortschritt}</td>
                        <td style={{
                            padding: "6px", textAlign: "right"
                        }}>{!isNaN(Number(item.MA)) ? Number(item.MA).toLocaleString('de-DE') : '-'}</td>
                        <td style={{
                            padding: "6px", textAlign: "right", fontWeight: "bold", backgroundColor: secondaryBackground
                        }}>{item.FP.toLocaleString("de-DE")}</td>
                    </tr>))}
                    </tbody>
                </table>
            </div>
            {/* Chart without labels */}
            <div style={{
                width: "55%",
                height: `${(data.length) * barHeight}px`,
                paddingTop: "27px",
                left: "-15px",
                position: "relative",
                zIndex: "0",
            }}>
                <Bar data={chartData} options={options}/>
            </div>
        </>)}
    </div>));
};

export default MilestoneChart;
